import ServiceCategoriasRef from "../services/serviceCategoriasRef";
import { initialStateTaxForSelectBoxes } from "../initialStates/infoFiscal";

function icms(ref) {
  const object = typeof ref.refObject === "string" ? JSON.parse(ref.refObject) : ref.refObject;
  return object?.icms?.[0] || {};
}

export default {
  data() {
    return { categoriasRefFiscal: [] };
  },
  computed: {
    refFiscalFilters() {
      const options = initialStateTaxForSelectBoxes.icms;
      return [
        {
          key: "idCategoriaRef",
          label: "Categoria",
          options: [
            { value: "none", text: "Sem categoria" },
            ...this.categoriasRefFiscal.map(({ id, nome }) => ({ value: id, text: nome })),
          ],
          getValue: (ref) => ref.idCategoriaRef || "none",
        },
        { key: "cenario", label: "Cenário", options: options.cenario, getValue: (ref) => icms(ref).cenario },
        { key: "tipoPessoa", label: "Tipo de pessoa", options: options.tipo_pessoa, getValue: (ref) => icms(ref).tipo_pessoa },
        { key: "cfop", label: "CFOP", placeholder: "Digite o CFOP", getValue: (ref) => icms(ref).codigo_cfop },
      ];
    },
  },
  methods: {
    async loadRefFiscalCategories() {
      try {
        this.categoriasRefFiscal = await ServiceCategoriasRef.findAll();
      } catch (error) {
        this.$toast.open({ message: "Não foi possível carregar as categorias de REF", type: "error" });
      }
    },
  },
};
